import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { buildWaLink } from "@/lib/api";

export function WhatsAppFloat() {
  const { settings } = useSettings();
  const { pathname } = useLocation();
  if (!settings.whatsapp_number || pathname.startsWith("/trips/")) return null;
  return (
    <a href={buildWaLink(settings.whatsapp_number, `Hi ${settings.brand_name || "Safarshala"}! I'd like to know more about your trips.`)}
      target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp" data-testid="whatsapp-float"
      className="fixed right-4 bottom-[max(1rem,env(safe-area-inset-bottom))] z-40 h-14 w-14 rounded-full bg-[#25D366] text-white shadow-xl shadow-black/20 grid place-items-center hover:scale-105 active:scale-95 transition-transform">
      <MessageCircle className="h-7 w-7" />
    </a>
  );
}
